import React from 'react';

import s from '../index.module.css';

export const ContactLink = () => {
  const SUPPORT_EMAIL = 'support@safariportal.app';
  const SUBJECT = 'Upgrade my plan';
  const BODY = "I'd like to upgrade to Tier II to be able to unlock flights search.";
  const mailtoLink = `mailto:${SUPPORT_EMAIL}?subject=${SUBJECT}&body=${BODY}`;

  return (
    <a href={mailtoLink} className={s.contactButton}>
      Contact
    </a>
  );
};
